import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import { brandColors } from 'styles/colors';

export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #878787;
	overflow: hidden;
	padding: 0 0 10% 0;
`;

export const LogoWrapper = styled.div`
	width: 96%;
	padding: 10px 0px 0px;
	background: transparent;
	display: flex;
	align-items: center;
	justify-content: start;
	gap: 20px;
`;

export const CompanyNameWrapper = styled.div`
	font-size: 20px;
	color: ${colors.white};
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: start;
	width: 96%;
	gap: 1.5%;
`;

export const InsightsBackgroundWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
	width: 50%;
`;

export const InsightsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const ModulesBackgroundWrapepr = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
	width: 50%;
`;

export const ModulesWrapper = styled.div`
	width: 100%;
`;

export const TitleWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;

	#settingIcon {
		position: absolute;
		right: 2%;

		&:focus {
			background-color: blue;
		}

		&:hover {
			.settingIcon {
				svg {
					fill: ${brandColors.green};
				}
			}
		}
	}

	.settingIcon {
		svg {
			fill: ${colors.white};
		}
	}
`;

export const InsightsInfoWrapper = styled.div`
	background-color: #cccccc;
	margin: 0 0 0% 0;
	border-radius: 10px;
	padding: 2%;
	height: 54.5vh;
	overflow: hidden;
	align-content: center;

	@media (max-width: 1366px) {
		height: 55vh;
	}
`;

export const ModulesInfoWrapper = styled.div`
	border-radius: 10px;
	padding-left: 7px;
	padding-right: 10px;
	padding-top: 5px;
	padding-bottom: 26px;
	height: 54.5vh;
	background-color: #cccccc;
	overflow: hidden;
	display: flex;
	justify-content: center;
	flex-direction: row;
	flex-wrap: wrap; /* Allow items to wrap to the next line */
	justify-content: space-between; /* Distribute space between items */

	/* Set a fixed width for each module item */
	& > * {
		flex: 1 1 calc(33.333% - 20px); /* Adjust the width of each module item */
		margin: 9px; /* Add margin around each module item */
		margin-right: 5px;
	}

	@media (max-width: 1366px) {
		& > * {
			flex: 1 1 calc(27% - 16px); /* Adjust for smaller screens */
			height: calc(25vh - 10px); /* Set height dynamically */
		}
	}
	@media screen and (max-width: 1024px) {
		border-radius: 0px;
	}
`;

export const KPIItem = styled.div`
	flex: 1 1 calc(33.333% - 16px);
	padding: 16px;
	border: 1px solid #ccc;
	border-radius: 8px;
	text-align: center;
	background-color: #f9f9f9;

	@media (max-width: 768px) {
		flex: 1 1 100%;
	}
`;

export const TableWrapper = styled.div`
	width: 100%;
	margin: 3% 0 0 0;

	.ag-theme-balham {
		width: 100%;
		font-family: 'Roboto';

		.ag-root,
		.ag-side-bar,
		.ag-root-wrapper,
		.ag-status-bar {
			border: none;
		}

		.ag-header-row {
			border-bottom: 0px;
		}

		.ag-header {
			background-color: transparent;
			border: none;
			color: ${colors.grey5};
		}

		.ag-header-cell {
			font-weight: normal;
			font-size: 11px;
			line-height: 13px;
			letter-spacing: 0.8px;
			padding-bottom: 5px;
			font-family: 'Roboto';

			.ag-header-cell-text {
				white-space: pre-line;
			}

			&.ag-numeric-header {
				text-align: right;
			}

			&::after {
				display: none;
			}
		}

		.ag-row {
			border: none;
			background-color: transparent;

			&.ag-row-last {
				border-bottom: none;
			}

			.ag-cell {
				font-size: 13px;
				font-weight: normal;
				line-height: 24px;
				letter-spacing: 0.3px;
				color: ${colors.grey5};
			}
		}

		.ag-floating-top-viewport {
			border: none;
		}

		.ag-floating-top {
			border-color: ${colors.grey3};
		}

		.ag-row-pinned {
			border: none;

			&.ag-row-last {
				border: none;
			}

			.ag-cell {
				font-weight: bold;
			}
		}

		.ag-header-row-column {
			border-bottom: 1px solid ${colors.grey3};
		}
	}
`;

export const LoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;
